import { render } from "./BookReg.vue?vue&type=template&id=64ef7d4e"
import script from "./BookReg.vue?vue&type=script&lang=js"
export * from "./BookReg.vue?vue&type=script&lang=js"

import "./BookReg.vue?vue&type=style&index=0&id=64ef7d4e&lang=css"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__